import { animate, style, transition, trigger } from '@angular/animations';

export const tipAnimation = trigger('tooltip', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('.1s ease-out', style({ opacity: 1 })),
  ]),
  transition(':leave', [style({ opacity: 1 }), animate('.1s', style({ opacity: 0 }))]),
]);

export const tipPerspectiveAnimation = trigger('tooltip', [
  transition(':enter', [
    style({ opacity: 0, transform: 'rotateX(-17deg)' }),
    animate('.18s ease-out', style({ opacity: 1, transform: 'rotateX(0)' })),
  ]),
  transition(':leave', [style({ opacity: 1 }), animate('.17s', style({ opacity: 0, transform: 'rotateX(-15deg)' }))]),
]);
